export default {
  // 作业方式
  orderTypeFilter (val) {
    const m = new Map([
      [1, '自查公区'],
      [2, '自查房间'],
      [3, '自查设施设备'],
      [4, '客户公区'],
      [5, '客户房间'],
      [6, '客户设施设备'],
      [7, '品控任务'],
      [8, '设备巡检任务'],
      [9, '升级工单'],
      [10, '设备保养任务'],
      [11, '巡逻巡更'],
      [12, '设施设备告警'],
      [13, '监控告警'],
      [14, '品控工单'],
      [15, '承接查验任务工单']
    ])
    return m.get(val) || '-'
  },
  orderNatureFilter (val) {
    const m = new Map([
      [0, '常规'],
      [1, '投诉'],
      [2, '差评'],
      [3, '快速'],
      [4, '升级'],
      [5, '品检'],
      [6, '承接查验']
    ])
    return m.get(val) || '-'
  },
  // 作业方式
  calcJobPattern (val) {
    const m = new Map([[1, '点位&标准'], [2, '点位'], [3, '标准'], [4, '动线'], [5, '分类&标准']])
    return m.get(val) || '-'
  },
  // 任务生成方式
  calcTaskCreatePattern (val) {
    const m = new Map([[1, '按项目'], [2, '按点位'], [3, '按组团'], [4, '按分组']])
    return m.get(val) || '-'
  },
  // 执行方式
  calcExecutePattern (val) {
    const m = new Map([[1, '扫码'], [2, '无限制']])
    return m.get(val) || '-'
  },
  // 执行顺序
  calcExecuteSequence (val) {
    switch (val) {
      case 0:
        return '无序'
      case 1:
        return '有序'
      default:
        return '-'
    }
  }
}
